<div *ngFor="let validationError of propertyNames">
  <div *ngIf="localizeErrorMessage(validationError)" [innerHtml]="localizeErrorMessage(validationError)"
    class="error-message">
  </div>
</div>